import { type ReactElement } from 'react';
import pick from 'lodash/pick';
import {
    IconBlock,
    IconBlockFilled,
    IconCheckedFilled,
    IconEditFilled,
    IconHistory,
    IconSelectFilled,
} from '@direct-frontend/components';
import { type OpenApiSchemaProductVariant, type OpenApiSchemaYmlGoodsModerationStatus } from '#shared/api/schema';

export const PRODUCT_VARIANT_STATUS_MAP: Record<Required<OpenApiSchemaProductVariant>['status'], string> = {
    PUBLISHED: 'Опубликован',
    DRAFT: 'Черновик',
    ARCHIVED: 'Архив',
    HIDDEN: 'Скрыт',
};

/**
 * Явно перечисляем доступные для отображения статусы
 *
 * на момент написания комментария статус DRAFT находится в проработке, а ARCHIVED нет необходимости показывать
 */
const enabledStatuses: Array<keyof typeof PRODUCT_VARIANT_STATUS_MAP> = ['PUBLISHED', 'HIDDEN'];

export const allowedProductStatuses = pick<Record<Required<OpenApiSchemaProductVariant>['status'], string>>(
    PRODUCT_VARIANT_STATUS_MAP,
    enabledStatuses
);

export const STATUS_ICON_MAP: Record<Required<OpenApiSchemaProductVariant>['status'], ReactElement> = {
    PUBLISHED: <IconSelectFilled role="main" color="green" size="12" />,
    ARCHIVED: <IconBlockFilled role="main" color="red" size="12" />,
    DRAFT: <IconEditFilled role="main" color="gray" size="12" />,
    HIDDEN: <IconBlockFilled role="main" color="red" size="12" />,
};

export const PRODUCT_MODERATION_PENDING_STATUSES: OpenApiSchemaYmlGoodsModerationStatus[] = ['IN_PROGRESS', 'BLOCKED'];

export const PRODUCT_MODERATION_STATUS_MAP: Record<
    Exclude<OpenApiSchemaYmlGoodsModerationStatus, 'OK'> | 'ALL',
    string
> = {
    ALL: 'Все',
    IN_PROGRESS: 'В процессе',
    BLOCKED: 'Не пройдена',
};

export const PRODUCT_MODERATION_STATUS_LABEL_MAP: Record<
    OpenApiSchemaYmlGoodsModerationStatus,
    {
        icon: ReactElement;
        label: string;
    }
> = {
    OK: {
        icon: <IconCheckedFilled role="main" color="green" size="12" />,
        label: 'Пройдена',
    },
    IN_PROGRESS: {
        icon: <IconHistory role="main" color="gray" size="12" />,
        label: 'В процессе',
    },
    BLOCKED: {
        icon: <IconBlock role="main" color="red" size="12" />,
        label: 'Не пройдена',
    },
};
